export default __webpack_public_path__ + "static/media/liverpool.a8119736.svg";